$(document).ready(function(){  

  $(document).on('click', 'button[type="button"].edit-size-button, #custom-size-btn, label.custom-size-swatch, .edit-size-button', function() {
      $.fancybox.open({
          src: '#custom-size-popup',
          type: 'inline',
          opts: {
              afterShow: function(instance, current) {
                  $('.fancybox-close-small').on('click', function() {
                      $('.custom-size-box .cancel-btn').trigger('click');
                  });

                  $(document).on("click", 'button[type="button"].edit-size-button', function(e) {
                      let inputs = $('.field-block select:not(:disabled), .field-block input');
                      let error = 0;
                      $('.field-block .error').hide();
                      let details = [];
                  
                      $(inputs).each(function (k, v) {
                          if($(v).val() == '') {
                              $(v).next('.error').show();
                              error += 1;
                          } else {
                              details[$(v).data('label')] = $(v).val(); 
                          }
                      });
                  
                      if(error == 0) {
                      } else {
                          $('.field-block .error').filter(function() {
                              return $(this).prev().val() == '';
                          }).show();
                      }
                  });
              }
          }
      });
  });

$(document).on('click', '.js-load-more', function() {
    var $this = $(this);
    loadMoreProducts($this);
});

function loadMoreProducts($this) {
    var totalPages = parseInt($('[data-all-pages]').val());
    var currentPage = parseInt($('[data-this-page]').val());
    var nextUrl = $('[data-next-link]').val();

    $this.attr('disabled', true).html('<span load-more-text>Loading...</span>');

    $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
            var $newContent = $(responseHTML).find('#product-grid ul').html();
            $('#product-grid ul').append($newContent);

            // Update next page values
            var nextPageNum = currentPage + 1;
            if (nextUrl.indexOf('page=') !== -1) {
                nextUrl = nextUrl.replace(/page=\d+/, 'page=' + (nextPageNum + 1));
            } else {
                nextUrl += (nextUrl.indexOf('?') !== -1 ? '&' : '?') + 'page=' + (nextPageNum + 1);
            }

            $('[data-next-link]').val(nextUrl);
            $('[data-this-page]').val(nextPageNum);

            if (nextPageNum >= totalPages) {
                $this.closest('.load-more_wrap').remove();
            } else {
                $this.html('<span load-more-text>Load more</span>').removeAttr('disabled');
            }
        },
        error: function() {
            $this.html('<span load-more-text>Error loading</span>');
        }
    });
}
  
  $(document).on('change', 'input.option-1', function() {
    let isCustomSizeSelected = $(this).val() === 'Custom Size';
    if (isCustomSizeSelected) {
        $('.product--add-to-cart-button').addClass('edit-size-button');
        $('.product--add-to-cart-button').attr('type', 'button');
    }else{
        $('.product--add-to-cart-button').removeClass('edit-size-button');
        $('.product--add-to-cart-button').attr('type', 'submit');
    }
  });
  
  $(".share-button").click(function() {
    $(".social-share-wrapper").toggleClass("expand");
  });
  
  $(document).on('click', '.custom-size-box .cancel-btn', function() {
   $('.fancybox-container').hide();
   $('body').removeClass('compensate-for-scrollbar');
    var isFormIncomplete = false;
    $('.custom-size-box select.required').each(function() {
      if ($(this).val() === '') {
        isFormIncomplete = true;
      }
    });
  
    if (isFormIncomplete) {
      $('.product--add-to-cart-button').addClass('edit-size-button');
      $('.product--add-to-cart-button').attr('type', 'button');
    }
    
  });
  $('#select-unit').on('change', function(){
    let val = $(this).val();
    $(`.field-diff-size`).hide();
    $(`.field-diff-size.${val}-data`).show();

    $(`.field-diff-size select`).attr('disabled', true);
    $(`.field-diff-size.${val}-data select`).attr('disabled', false);
  });
  $('.field-buttons .save-btn').on( "click", function(e) {
    let inputs = $('.field-block select:not(:disabled), .field-block input');
      $('.product--add-to-cart-button').attr('type', 'submit');
      $('.product--add-to-cart-button').removeClass('edit-size-button');
    
    let error = 0;
    $('.field-block .error').hide();
    let details = [];
    $(inputs).each(function (k,v) {
      if($(v).val() == ''){
        $(v).next('.error').show();
        error = error + 1;
      }else{
        details[$(v).data('label')] = $(v).val();
      }
    });
    if(error == 0){
      console.log(details);
      valueHtml = '';
      keyHtml = '';
      otherHTML = '';
      for (const property in details) {
        valueHtml = valueHtml+`<td>${details[property]}</td>`;
        keyHtml = keyHtml+`<td>${property}</td>`;
        otherHTML = otherHTML + `<input type="hidden" name="properties[${property}]" value="${details[property]}">`;
      }
        $('form .product--add-to-cart-button').after(`${otherHTML}`);
      
      $('#custom-size-details #custom-size-details-table').html(`<table><tbody>
        <tr>${keyHtml}</tr><tr>${valueHtml}</tr>
        </tbody></table>${otherHTML}`);
      $('#custom-size-details').show();
      $.fancybox.close();
    }
  });
  
  $('.exclusive-accessories-main-bg .exclusive-accessories').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

//if($('.collection-image-anim').length > 4){  
  $('.homepage-featured-products').slick({
    dots: false,
    infinite: true,
    arrows:true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
//}  
  
  $('.related-list').slick({
    dots: false,
    infinite: true,
    arrows:true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });

  var url_string = window.location.href; 
  var url = new URL(url_string);
  var c = url.searchParams.get("handle");
  if(c != null){
    
    jQuery.getJSON(window.Shopify.routes.root + 'products/'+c+'.js', function(product) {
      jQuery('#ContactForm-product').val(product.title);
    });
  }

// Custom PDP JS
  
  $('.toggle-links').click(function() {
      $('.dropdown-content').slideToggle(); 
  });

if ($('.slider-for-collection').length > 0) {
  console.log('yess')


  $(document).on("click",".quick-add-button-variants-desktop",function() {

   setTimeout(function() {
      $('.slider-galeria').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    //asNavFor: '.slider-galeria-thumbs',
  });
      }, 1500);
  });
    

}else{
    $('.slider-galeria').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    asNavFor: '.slider-galeria-thumbs',
  });
  $('.slider-galeria-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.slider-galeria',
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    infinite: false,
  });
}
  


  $('.slider-galeria').on('afterChange init', function(event, slick, currentSlide) {
    var activeSlide = $('.slider-galeria .slick-active');
    var newImageUrl = activeSlide.find('a[data-main-media-link]').attr('href');
    activeSlide.find('.product-img--main').attr('data-image', newImageUrl);
    activeSlide.find('img.theme-img').attr('src', newImageUrl);
    activeSlide.find('.product-img--main__image').css('background-image', 'url(' + newImageUrl + ')');
  });

  $('.slider-galeria').slick('setPosition');
  
  function updateCustomQuantity(value) {
      $('.quantity-custom').val(value); 
  }

  $('.qty-minus').on('click', function () {
      var $input = $(this).siblings('.quantity-selector');
      var currentValue = parseInt($input.val());
      if (currentValue > 1) {
          var newValue = currentValue - 1;
          $input.val(newValue);
          updateCustomQuantity(newValue); 
      }
  });

  $('.qty-plus').on('click', function () {
      var $input = $(this).siblings('.quantity-selector');
      var newValue = parseInt($input.val()) + 1;
      $input.val(newValue);
      updateCustomQuantity(newValue); 
  });


$('.product-img--main')
  .on('mouseover', function(){
    $(this).children('.product-img--main__image').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
  })
  .on('mouseout', function(){
    $(this).children('.product-img--main__image').css({'transform': 'scale(1)'});
  })
  .on('mousemove', function(e){
    $(this).children('.product-img--main__image').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
  })
  .each(function(){
    $(this)
      .append('<div class="product-img--main__image"></div>')
      .children('.product-img--main__image').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
  });
});

// Custom PDP JS

// Wow JS

(function() {
  var Util,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Util = (function() {
    function Util() {}

    Util.prototype.extend = function(custom, defaults) {
      var key, value;
      for (key in custom) {
        value = custom[key];
        if (value != null) {
          defaults[key] = value;
        }
      }
      return defaults;
    };

    Util.prototype.isMobile = function(agent) {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent);
    };

    return Util;

  })();

  this.WOW = (function() {
    WOW.prototype.defaults = {
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true
    };

    function WOW(options) {
      if (options == null) {
        options = {};
      }
      this.scrollCallback = __bind(this.scrollCallback, this);
      this.scrollHandler = __bind(this.scrollHandler, this);
      this.start = __bind(this.start, this);
      this.scrolled = true;
      this.config = this.util().extend(options, this.defaults);
    }

    WOW.prototype.init = function() {
      var _ref;
      this.element = window.document.documentElement;
      if ((_ref = document.readyState) === "interactive" || _ref === "complete") {
        return this.start();
      } else {
        return document.addEventListener('DOMContentLoaded', this.start);
      }
    };

    WOW.prototype.start = function() {
      var box, _i, _len, _ref;
      this.boxes = this.element.getElementsByClassName(this.config.boxClass);
      if (this.boxes.length) {
        if (this.disabled()) {
          return this.resetStyle();
        } else {
          _ref = this.boxes;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            box = _ref[_i];
            this.applyStyle(box, true);
          }
          window.addEventListener('scroll', this.scrollHandler, false);
          window.addEventListener('resize', this.scrollHandler, false);
          return this.interval = setInterval(this.scrollCallback, 50);
        }
      }
    };

    WOW.prototype.stop = function() {
      window.removeEventListener('scroll', this.scrollHandler, false);
      window.removeEventListener('resize', this.scrollHandler, false);
      if (this.interval != null) {
        return clearInterval(this.interval);
      }
    };

    WOW.prototype.show = function(box) {
      this.applyStyle(box);
      return box.className = "" + box.className + " " + this.config.animateClass;
    };

    WOW.prototype.applyStyle = function(box, hidden) {
      var delay, duration, iteration;
      duration = box.getAttribute('data-wow-duration');
      delay = box.getAttribute('data-wow-delay');
      iteration = box.getAttribute('data-wow-iteration');
      return box.setAttribute('style', this.customStyle(hidden, duration, delay, iteration));
    };

    WOW.prototype.resetStyle = function() {
      var box, _i, _len, _ref, _results;
      _ref = this.boxes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        box = _ref[_i];
        _results.push(box.setAttribute('style', 'visibility: visible;'));
      }
      return _results;
    };

    WOW.prototype.customStyle = function(hidden, duration, delay, iteration) {
      var style;
      style = hidden ? "visibility: hidden; -webkit-animation-name: none; -moz-animation-name: none; animation-name: none;" : "visibility: visible;";
      if (duration) {
        style += "-webkit-animation-duration: " + duration + "; -moz-animation-duration: " + duration + "; animation-duration: " + duration + ";";
      }
      if (delay) {
        style += "-webkit-animation-delay: " + delay + "; -moz-animation-delay: " + delay + "; animation-delay: " + delay + ";";
      }
      if (iteration) {
        style += "-webkit-animation-iteration-count: " + iteration + "; -moz-animation-iteration-count: " + iteration + "; animation-iteration-count: " + iteration + ";";
      }
      return style;
    };

    WOW.prototype.scrollHandler = function() {
      return this.scrolled = true;
    };

    WOW.prototype.scrollCallback = function() {
      var box;
      if (this.scrolled) {
        this.scrolled = false;
        this.boxes = (function() {
          var _i, _len, _ref, _results;
          _ref = this.boxes;
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            box = _ref[_i];
            if (!(box)) {
              continue;
            }
            if (this.isVisible(box)) {
              this.show(box);
              continue;
            }
            _results.push(box);
          }
          return _results;
        }).call(this);
        if (!this.boxes.length) {
          return this.stop();
        }
      }
    };

    WOW.prototype.offsetTop = function(element) {
      var top;
      top = element.offsetTop;
      while (element = element.offsetParent) {
        top += element.offsetTop;
      }
      return top;
    };

    WOW.prototype.isVisible = function(box) {
      var bottom, offset, top, viewBottom, viewTop;
      offset = box.getAttribute('data-wow-offset') || this.config.offset;
      viewTop = window.pageYOffset;
      viewBottom = viewTop + this.element.clientHeight - offset;
      top = this.offsetTop(box);
      bottom = top + box.clientHeight;
      return top <= viewBottom && bottom >= viewTop;
    };

    WOW.prototype.util = function() {
      return this._util || (this._util = new Util());
    };

    WOW.prototype.disabled = function() {
      return !this.config.mobile && this.util().isMobile(navigator.userAgent);
    };

    return WOW;

  })();

}).call(this);

wow = new WOW(
  {
    animateClass: 'animated',
    offset: 100
  }
);
wow.init();
// Wow JS

// Custom PDP JS
 $(document).on("click", ".variant-swatch", function() {
     var url = window.location.href;
     var parts = url.split("/");
     var lastPart = parts[parts.length - 1];
     if (lastPart.includes("?")) {
         var queryIndex = lastPart.indexOf("?");
         lastPart = lastPart.substring(0, queryIndex);
     }
     var product_handle = lastPart;
   
    var get_attr = $(this).parents(".swatch-items-wrapper").attr("data-attr");
    var get_value = $(this).find("input[type='radio']").val();
    $('.swatch-items-wrapper[data-attr="' + get_attr + '"] .variant-swatch').each(function(index) {
        $(this).removeClass("active");
    });
    
    $(this).addClass("active");
     var options = "";
     $(".swatch-items-wrapper .variant-swatch").each(function(index) {
         if ($(this).hasClass("active") == true) {
             var ot = $.trim($(this).text());
             options += "" + ot + " / ";
         }
     });
         options = options.slice(0, -3);
         jQuery.getJSON(window.Shopify.routes.root + "products/" + product_handle + ".js", function(product) {
             var product_v = product.variants;
             $(product_v).each(function(index, v) {

             var title = v.title;
             if (options == title) {
                var currentURL = new URL(window.location.href);
                currentURL.searchParams.set("variant", v.id);
                window.history.replaceState({}, "", currentURL);
                $(".product-variant-id").attr("value", v.id);
                $("input[name='product-id']").attr("value", v.id);
               
               
                $(".product-price-group span.money").text(Shopify.formatMoney(v.price) + " USD");
                if(v.featured_image.src != null){
                  $("body").find(".product-img--main img.theme-img-custom").attr("src", v.featured_image.src);
                  $("body").find(".product-img--main").attr("data-image", v.featured_image.src);
                  $("body").find(".product-img--main__image").css("background-image", `url(${v.featured_image.src})`);
                }
             }
         });
     });
 });


// Custom PDP JS


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

    // setTimeout(function() {
    //     if ($('.slider-for-collection').length) {
    //         $('.slider-galeria').removeClass('slider-galeria').addClass('slider-collection');
    //     }
    // }, 1000); 





// Popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');

      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });

  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });

  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});


$(document).ready(function(){
	$('.SizeChartPopup a').on('click', function() {		
        if ($('body').hasClass('popup-open'))
        { $('body').removeClass('popup-open'); }
        else
        { $('body').addClass('popup-open'); }
	});    
	
});